<pcg-resizable-widget>
    <span widget-title>NDC Lookup</span>
    <div class="d-flex flex-column px-4 pt-2" style="gap: 0.25em" widget-body>
        <p-autocomplete
            fluid
            inputStyleClass="widget-input"
            appendTo="body"
            [(ngModel)]="productName"
            [suggestions]="productSuggestions()"
            (completeMethod)="onProductSearch($event)"
            placeholder="Product Name..."
            (keydown.enter)="search()"
            (keydown.esc)="productName.set(null)"
        />

        <p-autocomplete
            fluid
            inputStyleClass="widget-input"
            appendTo="body"
            [(ngModel)]="ndc"
            [suggestions]="ndcSuggestions()"
            (completeMethod)="onNdcSearch($event)"
            placeholder="NDC..."
            (keydown.enter)="search()"
            (keydown.esc)="ndc.set(null)"
        />

        <input 
            class="w-100"
            placeholder="Lot Number..."
            [(ngModel)]="lotNumber"
            (keydown.enter)="search()"
            (keydown.esc)="lotNumber.set(null)"
        />

        <p-datepicker 
            fluid  
            showIcon="true"     
            appendTo="body"
            placeholder="Exp Date..."
            inputStyleClass="widget-input"
            [(ngModel)]="expDate"
            (keydown.enter)="search()"
            dataType="string"
            showOnFocus="false"
            (keydown.esc)="expDate.set(null)"
        />

        <button 
            class="btn btn-primary justify-content-center"
            (click)="search()"
        >
            <i class="pi pi-search"></i>
            Search
        </button>
    </div>
</pcg-resizable-widget>